import "../job-timeline/JobTimeline.scss";
import "./SavedJobs.scss";

import { useEffect, useState } from "react";
import Job from "../../../../../components/job/Job";
import { JobApiRoutes } from "../../../../../shared/api-routes/job/job-api.routes";
import http from "../../../../../shared/utils/http";

const SavedJobs: React.FC = () => {
	const [jobs, setJobs] = useState<any[]>([]);

	useEffect(() => {
		http.get(JobApiRoutes.GET_SAVED_JOBS).then(async (res) => {
			setJobs(
				await Promise.all(
					res.map((job_id: string) =>
						http.get(JobApiRoutes.GET_JOB_BY_ID(job_id))
					)
				)
			);
		});
	}, []);

	const handleUnsaveJob = (jobId: string) => {
		setJobs((prevJobs) => prevJobs.filter((job) => job.id !== jobId));
	};

	return (
		<div className="grand-container">
			<div className="job_timeline_container">
				<p className="jobs__caption">Saved Jobs</p>
				<div className="job-timeline board-container">
					{jobs.length > 0 ? (
						jobs.map((job: any, index: number) => (
							<Job
								jobInfo={job}
								key={index}
								onUnsaveJob={handleUnsaveJob}
							/>
						))
					) : (
						<div className="empty-state">
							<p className="empty-state__message">
								You haven't saved any job yet
							</p>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default SavedJobs;
